// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"439":"blueprint-icons-all-paths-loader","569":"blueprint-icons-split-paths-by-size-loader"}[chunkId] || chunkId) + "." + {"439":"83a84635","569":"6776e87f","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};